import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Loader2 } from "lucide-react";

export default function DepositsPage() {
  const { data: deposits, isLoading } = useQuery({
    queryKey: ["/api/user/deposits"],
  });

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-border" />
      </div>
    );
  }

  return (
    <div className="container mx-auto py-10">
      <h1 className="text-3xl font-bold mb-6">Deposit History</h1>
      <div className="rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Amount</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Transaction</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {deposits?.map((deposit) => (
              <TableRow key={deposit.id}>
                <TableCell>
                  {format(new Date(deposit.createdAt), "PPpp")}
                </TableCell>
                <TableCell>{deposit.amount} CB</TableCell>
                <TableCell>
                  <span className="capitalize">{deposit.status}</span>
                </TableCell>
                <TableCell className="font-mono">
                  <a
                    href={`https://solscan.io/tx/${deposit.transactionSignature}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    {deposit.transactionSignature.slice(0, 8)}...
                    {deposit.transactionSignature.slice(-8)}
                  </a>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
